<div>
    <div class="flex flex-col gap-8 md:flex-row">
        <div class="flex shrink grow basis-0 flex-col gap-8">
            <!-- Vertical -->
            <p-card header="Vertical">
                <div class="mt-2 flex flex-col gap-4">
                    <div class="flex flex-col gap-2">
                        <label for="name">Name</label>
                        <input pInputText />
                        <app-field-error message="Name is required." />
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="name">Email</label>
                        <input pInputText />
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="name">Age</label>
                        <input pInputText />
                    </div>
                    <div class="flex justify-end">
                        <p-button label="Submit" (onClick)="onSubmitTest()"/>
                    </div>
                </div>
            </p-card>

            <!-- Vertical Grid -->
            <p-card header="Vertical Grid">
                <div class="mt-2 flex flex-col flex-wrap gap-6 sm:flex-row">
                    <div class="flex shrink grow basis-auto flex-row flex-wrap gap-6">
                        <div class="flex min-w-[15rem] grow basis-0 flex-col gap-2">
                            <label class="" for="name">Name</label>
                            <input class="w-full" pInputText />
                        </div>
                        <div class="flex min-w-[15rem] grow basis-0 flex-col gap-2">
                            <label class="" for="name">Email</label>
                            <input class="w-full" pInputText />
                        </div>
                    </div>

                    <div class="flex basis-auto items-end justify-end">
                        <p-button label="Submit" />
                    </div>
                </div>
            </p-card>
        </div>

        <div class="flex shrink grow basis-0 flex-col gap-8">
            <p-card header="Horizontal">
                <div class="mt-2 flex flex-col gap-4">
                    <div class="grid grid-cols-12 gap-2">
                        <div class="col-span-12 flex items-center sm:col-span-2">
                            <label for="name">Name</label>
                        </div>
                        <input class="col-span-12 sm:col-span-10" pInputText />
                    </div>
                    <div class="grid grid-cols-12 gap-2">
                        <div class="col-span-12 flex items-center sm:col-span-2">
                            <label for="name">Email</label>
                        </div>
                        <input class="col-span-12 sm:col-span-10" pInputText />
                    </div>
                    <div class="grid grid-cols-12 gap-2">
                        <div class="col-span-12 flex items-center sm:col-span-2">
                            <label for="name">Age</label>
                        </div>
                        <input class="col-span-12 sm:col-span-10" pInputText />
                    </div>
                    <div class="flex justify-end">
                        <p-button label="Submit" />
                    </div>
                </div>
            </p-card>

            <p-card header="Inline">
                <div class="mt-4 flex flex-col gap-10">
                    <div class="flex flex-col justify-between gap-6 md:flex-row md:gap-4">
                        <p-floatLabel class="auto shrink grow">
                            <input pInputText class="w-full" id="name_over_label" autocomplete="off" />
                            <label for="name_over_label">Name</label>
                        </p-floatLabel>
                        <p-floatLabel class="auto shrink grow">
                            <input pInputText class="w-full" id="email_over_label" autocomplete="off" />
                            <label for="email_over_label">Email</label>
                        </p-floatLabel>
                        <div class="flex items-end justify-end">
                            <p-button label="Submit" />
                        </div>
                    </div>

                    <div class="flex flex-col justify-between gap-6 md:flex-row md:gap-4">
                        <p-floatLabel variant="on" class="auto shrink grow">
                            <input pInputText class="w-full" id="name_on_label" autocomplete="off" />
                            <label for="name_on_label">Name</label>
                        </p-floatLabel>
                        <p-floatLabel variant="on" class="auto shrink grow">
                            <input pInputText class="w-full" id="email_on_label" autocomplete="off" />
                            <label for="email_on_label">Email</label>
                        </p-floatLabel>
                        <div class="flex items-end justify-end">
                            <p-button label="Submit" />
                        </div>
                    </div>

                    <div class="flex flex-col items-center justify-between gap-6 md:flex-row md:gap-4">
                        <p-floatLabel variant="in" class="auto w-full shrink grow">
                            <input pInputText class="w-full" id="name_in_label" autocomplete="off" />
                            <label for="name_in_label">Name</label>
                        </p-floatLabel>
                        <p-floatLabel variant="in" class="auto w-full shrink grow">
                            <input pInputText class="w-full" id="email_in_label" autocomplete="off" />
                            <label for="email_in_label">Email</label>
                        </p-floatLabel>
                        <div class="flex items-end justify-end">
                            <p-button label="Submit" />
                        </div>
                    </div>

                    <div class="flex flex-col justify-between gap-6 md:flex-row md:gap-4">
                        <input pInputText class="w-full" id="name_in_label" autocomplete="off" placeholder="Name" />

                        <input pInputText class="w-full" id="email_in_label" autocomplete="off" placeholder="Email" />

                        <div class="flex items-end justify-end">
                            <p-button label="Submit" />
                        </div>
                    </div>
                </div>
            </p-card>

            <p-card header="Help Text">
                <div class="mt-2 flex flex-col gap-4">
                    <div class="flex flex-col gap-2">
                        <label for="name">Username</label>
                        <input pInputText class="w-full" />
                        <small id="name-help">Enter your username to reset your password</small>
                    </div>
                    <div class="flex justify-end gap-4">
                        <p-button severity="secondary" [outlined]="true" label="Cancel" />
                        <p-button label="Submit" />
                    </div>
                </div>
            </p-card>
        </div>
    </div>

    <div class="mt-8">
        <p-card header="Advanced">
            <div class="flex flex-col gap-6">
                <!-- First / Last Name -->
                <div class="flex flex-col gap-6 md:flex-row">
                    <div class="flex shrink grow flex-col gap-2">
                        <label>First Name</label>
                        <input pInputText />
                    </div>
                    <div class="flex shrink grow flex-col gap-2">
                        <label>Last Name</label>
                        <input pInputText />
                    </div>
                </div>

                <div class="flex flex-col gap-2">
                    <label>Address</label>
                    <textarea rows="5" pTextarea></textarea>
                </div>

                <div class="flex flex-col gap-6 md:flex-row">
                    <div class="flex shrink grow basis-1/2 flex-col gap-2">
                        <label>State</label>
                        <p-select [options]="cities" optionLabel="name" placeholder="Select a City"></p-select>
                    </div>
                    <div class="flex shrink grow basis-1/2 flex-col gap-2">
                        <label>Zip</label>
                        <input pInputText />
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <div class="mt-8">
        <p-card>
            <div class="mb-8 flex flex-wrap gap-4">
                <p-button label="Primary" [raised]="true" />
                <p-button label="Secondary" severity="secondary" />
                <p-button label="Success" severity="success" />
                <p-button label="Info" severity="info" />
                <p-button label="Warn" severity="warn" />
                <p-button label="Help" severity="help" />
                <p-button label="Danger" severity="danger" (onClick)="onMessageTest()"/>
                <p-button label="Contrast" severity="contrast" />
            </div>

            <div class="mb-8 flex flex-wrap gap-4">
                <p-button label="Primary" [raised]="true" />
                <p-button label="Secondary" severity="secondary" [raised]="true" />
                <p-button label="Success" severity="success" [raised]="true" />
                <p-button label="Info" severity="info" [raised]="true" />
                <p-button label="Warn" severity="warn" [raised]="true" />
                <p-button label="Help" severity="help" [raised]="true" />
                <p-button label="Danger" severity="danger" [raised]="true" (onClick)="onMessageTest()" />
                <p-button label="Contrast" severity="contrast" [raised]="true" />
            </div>

            <div class="mb-8 flex flex-col gap-4">
                <span class="">Standard: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>

                <span class="text-primary">Primary: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-secondary">Secondary: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                
                <span class="text-success">Success: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-warning">Warning: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-danger">Danger: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-error">Error: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>

                <span class="text-info">Info: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-help">Help: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-contrast bg-(--p-primary-color)">Contrast on Primary: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>

                <span class="text-contrast bg-success">Contrast on Success: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-contrast bg-error">Contrast on Error: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="text-contrast bg-danger">Contrast on Danger: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>

                <span class="border-success border-2">Border Success: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="border-danger border-2">Border Danger: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
                <span class="border-error border-2">Border Error: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span>
            </div>
        </p-card>
    </div>

    <div class="mt-8">
        <p-card header="Force Scroll Bar">
            <p>User Context: {{userContextStringify()}}</p>
            <br>
            <h1>Permissions Checks</h1>
            <p>Manage Subscribers (SysAdmin): 
                @if (permissionService.hasPermission('sysAdmin')) {
                    <span>Yes</span>
                } @else {
                    <span>No</span>
                }
            </p>

            <p>Admin: 
                 @if (permissionService.hasPermission('admin')) {
                    <span>Yes</span>
                } @else {
                    <span>No</span>
                }
            </p>

            <p>Cost Viewer: 
                 @if (permissionService.hasPermission('canViewCost')) {
                    <span>Yes</span>
                } @else {
                    <span>No</span>
                }
            </p>
                
            <ng-template #falseTemplate>
                <span>False!!!</span>
            </ng-template>
            <div class="h-200"></div>
        </p-card>
    </div>
</div>
